<template>
  <div class="ubicacion">
    <small class="font-weight-bold">{{stock.ubicacion.join(" | ") | ubicacion}}</small>
  </div>
</template>

<script>
  export default {
    name: "Ubicacion",
    props: {
      stock: {
        type: Object,
        default: () => {}
      }
    },
    filters: {
      ubicacion(value) {
        return value.length === 0 ? "Sin Ubicacion" : value
      }
    }
  }
</script>

<style scoped>
  .ubicacion {
    animation: fadeIn linear 200ms;
  }

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
    from {
      opacity: 0
    }
  }

</style>
